<template>
  <b-modal
    id="reviewListPopup"
    :title="isEditing ? 'リスト編集' : 'リスト新規作成'"
    size="lg"
    ref="reviewListPopup"
    @hide="hideModal"
    @show="showModal"
    hide-footer
  >
    <div class="main-container">
      <Loader v-show="loading" />
      <div
        class="w-100 row no-gutters main-area inner-form-section"
        v-show="!loading"
        style="background: none;box-shadow: none;"
      >
        <div class="col-md-12 col-form-section">
          <div class="form-section">
            <div class="form-detail">
              <form>
                <input
                  type="hidden"
                  name="password_method"
                  value="is_activation_link"
                />
                <div class="form-detail-block">
                  <div class="custom-form-block">
                    <div class="form-group">
                      <div class="row" style="margin-bottom: 20px;">
                        <label class="col-md-3 col-form-label font-bold"
                          >リスト名（必須）</label
                        >
                        <div
                          class="col-md-9"
                          style="max-height: 400px; overflow: auto;"
                        >
                          <input
                            type="text"
                            class="form-control"
                            name="title"
                            v-bind:class="{ 'is-invalid': hasError('title') }"
                            v-model="title"
                            v-validate="'required|max:50'"
                            data-vv-as="リスト名"
                            placeholder="任意のリスト名を入力してください"
                          />
                          <div
                            class="invalid-feedback"
                            v-if="hasError('title')"
                          >
                            <!-- <span class="icon-error">!</span
                            > -->
                            {{ getErrorMessage('title') }}
                          </div>
                        </div>
                      </div>
                      <div class="row mt-4">
                        <label class="col-md-3 col-form-label col-user font-bold">
                          閲覧権限
                        </label>
                        <div class="col-md-9">
                          <label class="info-label">
                            ※既に他のリストに閲覧設定されているアカウントは選択できません
                          </label>
                          <div class="div" style="max-height: 600px; overflow: auto;">
                            <div
                              class="mb-2 mt-3"                     
                              v-for="user in reviewListUsers"
                              v-bind:key="user.id"
                            >
                            <div class="form-check d-flex align-items-center m-0">
                              <input
                                type="checkbox"
                                :id="user.id"
                                :value="user.id"
                                class="form-check-input custom-checkbox m-0"
                                style="position: static; margin-right: 8px !important;"
                                v-model="reviewListModel"
                                :class="
                                  checkToDisable(user.id) ? 'awesome' : ''
                                "
                                :disabled="checkToDisable(user.id)"
                              />
                              <label
                                class="form-check-label m-0"
                                style="line-height: normal; padding: 0;"
                                :for="user.id"
                                >{{ user.name }}</label
                              >
                            </div>
                          </div>
                          </div>
                          <div
                            class="invalid-feedback"
                            v-if="hasError('reviewListUsers')"
                          >
                            <!-- <span class="icon-error">!</span
                            > -->
                            {{ getErrorMessage('reviewListUsers') }}
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                  <!-- ends custom-form-block -->
                </div>
                <!-- ends form-detail-block -->
                <div
                  class="btn-toolbar justify-content-center"
                  role="toolbar"
                  aria-label="Toolbar with button groups"
                  style="gap: 20px; margin-left: 10px"
                >
                  <button
                    id="users"
                    class="btn btn-rounded-plain me-1"
                    @click.prevent="hideModal()"
                  >
                    キャンセル
                  </button>
                  <button class="btn btn-rounded-md teal-bg" type="submit" @click.prevent="createReviewList">
                    {{ saveText }}
                  </button>
                </div>
              </form>
            </div>
            <!-- ends form-detail -->
          </div>
          <!-- ends form-section -->
        </div>
      </div>
      <!-- ends main-area -->
    </div>
  </b-modal>
</template>
<script>
import Api from '@/config/api';
import ApiService from '@/service/apiService';
import { mapMutations, mapGetters, mapActions } from 'vuex';
import { checkIsReviewerAndRedirect } from '@/utils/checkReviewer.js';
import Loader from '@/components/utils/Loader.vue';

export default {
  name: 'CreateReviewList',
  components: { Loader },
  props: {
    isEditing: {
      type: Boolean,
      required: true,
    },
    reviewLists: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      title: '',
      serverErrors: {},
      loading: false,
    };
  },
  async mounted() {
    this.$refs.reviewListPopup.show();
    // this.changeBodyBackground();
    if (!this.getCurrentUser) {
      await this.loadCurrentUser();
    }
    // if (!this.isReviewer) {
    //   this.$router.push({ path: '/applicant' });
    // }
  },
  computed: {
    ...mapGetters({
      users: 'getUsers',
      getCurrentUser: 'getCurrentUser',
      isAdmin: 'currentUserIsAdmin',
      isReviewer: 'isCreateReviewUser',
      reviewListUsers: 'getReviewListUsers',
      getReviewListUserModel: 'getReviewListUserModel',
      getReviewLists: 'getReviewLists',
    }),
    saveText() {
      return this.isEditing ? '保存する' : '保存する';
    },
    reviewListModel: {
      get() {
        return this.getReviewListUserModel;
      },
      set(value) {
        this.setReviewListUserModel(value);
      },
    },
  },
  methods: {
    ...mapMutations({
      setUser: 'setUser',
      setReviewListUserModel: 'setReviewListUserModel',
      updateReviewList: 'updateReviewList',
    }),
    ...mapActions({
      loadReviewListUsers: 'reviewListUsers',
      loadReviewLists: 'loadReviewLists',
      loadCurrentUser: 'loadCurrentUser',
    }),
    hideModal() {
      // this.$refs.reviewListPopup.hide();
      this.$emit('hideModal');
    },
    showModal() {
      this.$refs.reviewListPopup.show();
    },
    hasError(field) {
      return (
        field in this.serverErrors || this.formErrors.first(field) !== undefined
      );
    },
    getErrorMessage(field) {
      if (this.formErrors.first(field) !== undefined)
        return this.formErrors.first(field);
      else if (field in this.serverErrors) return this.serverErrors[field].msg;
      return '';
    },
    checkToDisable(id) {
      // For new lists, check if user is already in any list
      const clientUserIds = [];
      for (const reviewList of this.getReviewLists) {
        // If editing, skip the current list's users
        if (this.isEditing && reviewList._id === this.reviewLists._id) {
          continue;
        }
        for (const clientUser of reviewList.client_users) {
          clientUserIds.push(clientUser._id);
        }
      }
      return clientUserIds.includes(id);
    },
    async createReviewList() {
      const check = await this.$validator.validate();
      if (check) {
        this.loading = true;
        let data = {
          title: this.title,
          client_users: this.getReviewListUserModel,
        };
        let endpoint;
        if (this.isEditing) {
          endpoint = Api.endpoints.EDIT_REVIEW_LIST(this.reviewLists._id);
        } else {
          endpoint = Api.endpoints.CREATE_REVIEW_LIST;
        }
        ApiService.post(endpoint, data) // eslint-disable-next-line
          .then(({ data }) => {
            // this.setUser(data.data);
            this.updateReviewList(data);
            this.loading = false;
            this.hideModal();
            // this.$router.push({ path: '/setting/review-list' });
          })
          .catch((error) => {
            this.loading = false;
            console.log(error);
            if (error.response.status === 422) {
              this.serverErrors = error.response.data;
            } else {
              this.parseErrorResponse(error.response);
            }
          });
      }
    },
  },
  async created() {
    if (this.reviewListUsers && !this.reviewListUsers.length) {
      await this.loadReviewListUsers();
    }
    if (this.getReviewLists && !this.getReviewLists.length) {
      await this.loadReviewLists();
    }
    if (this.isEditing) {
      const id = this.reviewLists._id;
      const reviewList = this.getReviewLists.find((list) => list._id === id);
      this.title = reviewList.title;
      const client_users = reviewList.client_users.map((user) => {
        return user._id;
      });
      this.reviewListModel = client_users;
    } else {
      this.setReviewListUserModel([]);
    }
  },
  // beforeRouteEnter(to, from, next) {
  //   checkIsReviewerAndRedirect
  //     .call('/applicant', this)
  //     .then(() => {
  //       next();
  //     })
  //     .catch(() => {
  //       next();
  //     });
  // },
};
</script>

<style scoped>
>>> .modal-header {
  border-bottom: none !important;
}
.col-form-label.font-bold {
  font-weight: bold !important;
}
.info-label {
  color: #ff0000;
  font-weight: 400;
}
.custom-form-block .form-control {
  border: 2px solid #3c3c3c;
  border-bottom: 2px solid #3c3c3c !important;
  padding: 0px 10px;
}
.custom-form-block label {
  text-transform: none !important;
}
input[type='checkbox'] {
  width: 20px;
  height: 20px;
}
/* Disabled state color */
.custom-checkbox:disabled {
  color: #b3b3b3;
  accent-color: #B3B3B3;
  border-color: #b3b3b3 !important;
  filter: invert(25%);
  cursor: not-allowed;
}
/* input[type='checkbox']:disabled {
  accent-color: #B3B3B3;
  cursor: not-allowed;
} */
.col-form-label {
  font-size: 14px;
  font-weight: normal;
  color: #3c3c3c;
}
.col-form-label.col-user {
  display: flex;
  flex-direction: column;
}
.col-detail {
  margin-top: 10px;
  color: #000;
  font-weight: normal;
}
p {
  color: #3c3c3c;
  font-weight: bold;
  font-size: 24px;
}
.form-check-label {
  color: #3c3c3c;
  font-weight: normal !important;
}


.form-check-input[disabled] ~ .form-check-label,
.form-check-input:disabled ~ .form-check-label {
  color: #3c3c3c;
}

.inner-form-section {
  /* max-width: 700px; */
  margin-left: auto;
  margin-right: auto;
}

.inner-form-section .form-detail {
  max-height: 100%;
}

.form-check-inline .form-check-input {
  position: static;
  margin-top: 0;
  margin-right: 0.3125rem;
  margin-left: 0;
}

.btn-rounded-plain {
  background-color: #797978 !important;
  color: #fff !important;
}

.btn-rounded-plain:hover {
  background-color: #666 !important;
}
</style>
